'use client'

import { FlightSearchPageResponse } from '@/src/types/seoSrpResult'
import React, { createContext, ReactNode, useContext } from 'react'

// Define the context type
interface SrpContextType {
    SEOSrpData: FlightSearchPageResponse
}

const initialState: SrpContextType = {
    SEOSrpData: {
        card: null,
        seo: null,
        pageData: null,
        searchQuery: null,
        filterData: null,
        json: null,
        jsonLddata: null
    }
}
// Create the context with undefined as default
const SrpContext = createContext<SrpContextType>(initialState)

// Provider props interface
interface SrpProviderProps {
    children: ReactNode
    srpData: FlightSearchPageResponse
}

// SRP Context Provider component
export const SrpProvider: React.FC<SrpProviderProps> = ({ children, srpData }) => {
    const contextValue: SrpContextType = {
        SEOSrpData: srpData
    }

    return <SrpContext.Provider value={contextValue}>{children}</SrpContext.Provider>
}

// Custom hook to use the SRP context
export const useSrpContext = () => {
    const context = useContext(SrpContext)

    return context
}

// Export the context for advanced use cases (optional)
export { SrpContext }
